"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativeMediaImage = void 0;
var React = require("react");
var media_image_1 = require("wix-ui-core/dist/src/components/media-image");
var RelativeMediaImage_st_css_1 = require("./RelativeMediaImage.st.css");
var TPAComponentsConfig_1 = require("../../TPAComponentsConfig");
var Placeholder = function (_a) {
    var src = _a.src, className = _a.className, sourceDimensions = _a.sourceDimensions, containerDimensions = _a.containerDimensions, focalPoint = _a.focalPoint, isSEOBot = _a.isSEOBot, imageProps = __rest(_a, ["src", "className", "sourceDimensions", "containerDimensions", "focalPoint", "isSEOBot"]);
    return (React.createElement(media_image_1.MediaImage, __assign({ mediaPlatformItem: __assign(__assign({ uri: src }, sourceDimensions), { options: {
                focalPoint: focalPoint,
                filters: {
                    blur: 3,
                },
                isSEOBot: isSEOBot,
            } }), className: className }, containerDimensions, imageProps)));
};
var RelativeMediaImage = /** @class */ (function (_super) {
    __extends(RelativeMediaImage, _super);
    function RelativeMediaImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RelativeMediaImage.prototype.render = function () {
        var _a = this.props, src = _a.src, className = _a.className, sourceDimensions = _a.sourceDimensions, containerDimensions = _a.containerDimensions, isPlaceholderDisplayed = _a.isPlaceholderDisplayed, focalPoint = _a.focalPoint, onLoad = _a.onLoad, nativeRef = _a.nativeRef, imageProps = __rest(_a, ["src", "className", "sourceDimensions", "containerDimensions", "isPlaceholderDisplayed", "focalPoint", "onLoad", "nativeRef"]);
        return (containerDimensions && (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
            var seo = _a.seo;
            return (React.createElement(React.Fragment, null,
                isPlaceholderDisplayed && (React.createElement(Placeholder, __assign({ src: src, className: RelativeMediaImage_st_css_1.st(RelativeMediaImage_st_css_1.classes.placeholder, className), sourceDimensions: sourceDimensions, containerDimensions: containerDimensions, focalPoint: focalPoint, nativeRef: nativeRef, isSEOBot: seo }, imageProps))),
                React.createElement(media_image_1.MediaImage, __assign({ mediaPlatformItem: __assign(__assign({ uri: src }, sourceDimensions), { options: {
                            focalPoint: focalPoint,
                            isSEOBot: seo,
                        } }), className: RelativeMediaImage_st_css_1.st(RelativeMediaImage_st_css_1.classes.root, className), onLoad: onLoad }, containerDimensions, imageProps))));
        })));
    };
    return RelativeMediaImage;
}(React.Component));
exports.RelativeMediaImage = RelativeMediaImage;
//# sourceMappingURL=RelativeMediaImage.js.map